import { Component, Input, ViewChild, EventEmitter, Output, inject } from '@angular/core';
import { TreeNode } from 'primeng/api';
import { Discrepancy } from '../../models/discrepancy';
import { VarianceService } from 'src/app/services/variance.service';
import { ResolutionCodingService } from 'src/app/services/resolution-coding.service';
import { getLocalTimeOffset } from 'src/app/shared/timezone.util';
import { environment } from 'src/environments/environment';
import { CompiledRecord } from 'src/app/models/compiled-record';
import { AdcRecord } from 'src/app/models/adc-record';
import { UtilityService } from 'src/app/services/utility.service';
import { CommentModalComponent } from '../comment-modal/comment-modal.component';
import { CommentModalComponent as WmCommentModalComponent } from 'src/app/waste-module/comment-modal/comment-modal.component';
import { MessageService } from 'primeng/api'; 
import { DocumentService } from 'src/app/services/document.service';
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { ILogger, LOGGER_TOKEN } from 'src/app/services/logger/ilogger';
import { PrintAuthUrlService } from 'src/app/services/print-auth-url.service';

@Component({
    selector: 'app-linked-records-modal',
    templateUrl: './link-records-modal.component.html',
    styleUrls: ['./link-records-modal.component.css'],
    providers: [ ConfirmationService, DynamicDialogRef],
    standalone: false
})
export class LinkRecordsModalComponent {
  private readonly logger = inject<ILogger>(LOGGER_TOKEN);
  private varService = inject(VarianceService);
  private resolutionCodingService = inject(ResolutionCodingService);
  utility = inject(UtilityService);
  private messageService = inject(MessageService);
  private docmentService = inject(DocumentService);
  confirmationService = inject(ConfirmationService);
  private printAuthUrlService = inject(PrintAuthUrlService);

  varianceNodes: TreeNode[] = [];
  commentDialog   = false;
  @Input() selectedRow: any ;
  mainRecord:any;
  practiceIssueOptions: any;
  wmCommentDialog = false;
  selectAll = false;
  allNodes:any;
  tableDataIsLoading = false;
  @Output() completed = new EventEmitter<any>();
  @Output() linkModalRecordsRemoved = new EventEmitter<any>();
  @ViewChild('commentModal') commentModal!: CommentModalComponent;
  @ViewChild('wmCommentModal') wmCommentModal!: WmCommentModalComponent;
  @Output() commentSaved = new EventEmitter<boolean>();



  updateTable(rowData: any){
    this.selectAll = false;
    this.getTreeNodes(rowData)
  }

  checkUncheckAll(e: any) {
    if(e.target.checked){
      for (const varianceNode of this.varianceNodes) {
        varianceNode["data"].isSelected = true;
      }
    } 
    else{
      for (const varianceNode of this.varianceNodes) {
        varianceNode["data"].isSelected = false;
      }
    }
  }


  getTreeNodes(rowData: any) {
    this.mainRecord = rowData
    this.varService
      .getActivityLinkedRecords(rowData.id)
      .subscribe((resp: any) => {
        this.varianceNodes = resp.map((val: any) => {
          const node = Discrepancy.toTreeNode(Discrepancy.fromJSON(val)) as TreeNode;
          node.children = [];
          node.children.push(this.getSubOption("ADC Data"));
          if (val["source"] == null)
            node.children.push(this.getSubOption("EHR Data"));
          return node;
        }) as TreeNode[];
        this.allNodes = this.varianceNodes;
      });
   }

  submitMessageCompleted($event: any)
  {
    this.commentDialog = false;
    this.wmCommentDialog = false;
    this.commentSaved.emit(true)
    if (typeof $event !== 'boolean'){
      this.messageService.add($event);
   }
  }

  showCommentEdit(rowData: any){
    this.messageService.clear();
    this.selectedRow = rowData;
    this.docmentService.tab = 1
    if(rowData.source!=null)
    {
      this.wmCommentDialog = !this.wmCommentDialog
      this.wmCommentModal.getComments(rowData)
    }

    else
    {
    this.commentDialog = !this.commentDialog
    this.commentModal.getComments(rowData);
    }


  }

  formatVarianceNotReady(rowData: any) {
    if (rowData.resolutionCoding == "Pending Assay (checking on code)") {
      return "N/A";
    } else {
      return "";
    }
  }

  expandNode(event: any){
    event.node.expanded = !event.node.expanded;
    const node = event.node;
    if ( node.parent == null) {
      this.loadChildData(node.children![0]);
      this.loadChildData(node.children![1]);
      this.loadChildData(node.children![2]);
    }
    this.varianceNodes = [...this.varianceNodes];
    return;
  }

  loadChildData(node: any)
  
  {
    if(node == null)
    {
      return;
    }
    const uniqueKey2 = node.parent['data']['uniqueKey2'];
     if(node.data["label"]=="Compiled Data")
      {
        const maapkey = node.parent['data']['maapKey'];
        if(!("children" in node.children[0]))
        {
          this.tableDataIsLoading = true;
          this.varService.getCompiledData(maapkey, uniqueKey2, node.parent['data']["facilityId"]).subscribe(
            (res)=>{
              let data;
              if((res as any)["docs"].length>0)
              data = (res as any)["docs"]
              else
              data = [{}]
              node.children = data.map((val: any) => {
                return CompiledRecord.toTreeNode(CompiledRecord.fromJSON(val)) as TreeNode;
              });

              // this.varianceNodes = [...this.varianceNodes];
              this.tableDataIsLoading = false;
            },
            (err) => { 
              this.logger.exception(err);
              this.tableDataIsLoading = false;
            }
          );
        }
      }
      else if(node.data["label"]=="EHR Data")
      {
        const maapkey = node.parent['data']['maapKey'];
        const uniqueKey2 = node.parent['data']['uniqueKey2'];
        const mrn = node.parent['data']['mrnNum'];
        if(!("children" in node.children[0]))
        {
          this.tableDataIsLoading = true;
          this.varService.getEhrData(maapkey, uniqueKey2, mrn, node.parent['data']["facilityId"]).subscribe(
            (res)=>{
              let data;
              if((res as any)["docs"].length>0)
               data = (res as any)["docs"]
              else
               data = [{}]
              node.expanded = true
              node.children = data.map((val: any) => {
                return AdcRecord.toTreeNode(AdcRecord.fromJSON(val)) as TreeNode;
              });
              this.varianceNodes = [...this.varianceNodes];
              this.tableDataIsLoading = false;
            },
            (err) => { 
              this.logger.exception(err);
              this.tableDataIsLoading = false;
            }
          );
        }
      }
      else if(node.data["label"]=="ADC Data")
      {
        const maapkey = node.parent['data']['maapKey'];
        const uniqueKey2 = node.parent['data']['uniqueKey2'];
        const mrn = node.parent['data']['mrnNum'];
        if(!("children" in node.children[0]))
        {
          this.tableDataIsLoading = true;
          this.varService.getAdcData(maapkey, uniqueKey2, mrn, node.parent['data']["facilityId"]).subscribe(
            (res)=>{
              let data;
              if((res as any)["docs"].length>0)
               data = (res as any)["docs"]
              else
               data = [{}]
              node.expanded = true
              node.children = data.map((val: any) => {
                return AdcRecord.toTreeNode(AdcRecord.fromJSON(val)) as TreeNode;
              });
              this.varianceNodes = [...this.varianceNodes];
              this.tableDataIsLoading = false;
            },
            (err) => { 
              this.logger.exception(err);
              this.tableDataIsLoading = false;
            }
          );
        }
      }


  }

  onNodeExpand(event: any) {
    const node: TreeNode = event.node;
    if ( node.parent == null) {


      this.loadChildData(node.children![0]);
      this.loadChildData(node.children![1]);
      this.loadChildData(node.children![2]);
      return;
    }
  }
  getSubOption(str: any) {
    return {
      "data": {
        "label": str
      },
      children: [{}]
    }
  }
  getNodeLevel(node: any)
  {
    if(node.parent == null)
    {
      return 1;
    }
    else if(node.parent.parent==null)
    {
      return 2;
    }
    else
    {
      return 3;
    }

  }



  getResolutionBg(val: any)
  {
   return this.resolutionCodingService.getReolutionCodingBg(val);
  }

  

  rowClass(rowtype: any){
    if(rowtype == 'Compiled Data')
    {
      return "row-compiled-data";
    }else if(rowtype == 'ADC Data')
    {
      return "row-adc-data";
    }else if(rowtype == 'EHR Data')
    {
      return "row-ehr-data";
    }
  }

  getChildRowClass(rowtype: any){
    if(rowtype == 'Compiled Data')
    {
      return "detailsrow-compiled-data";
    }else if(rowtype == 'ADC Data')
    {
      return "detailsrow-adc-data";
    }else if(rowtype == 'EHR Data')
    {
      return "detailsrow-ehr-data";
    }
  }

  openPrintUrl(row: any){
    const url = environment.apiUrl+'print';
    const timeOffset = getLocalTimeOffset();
    this.varService.requestToken({maap_key:row.maapKey,unique_key:row.uniqueKey2}).subscribe(
      (res) => this.printAuthUrlService.openAuthenticatedPrint(url+"?token="+res+"&timeOffset="+timeOffset)
    )

  }


  onHideModal() {
    this.commentModal.stopPolling()
  }

  onShowModal() {
    this.commentModal.startPolling()
  }

  getItemsToBeShared(){
    return this.varianceNodes.filter(node => node.data["shareThis"]== true)
  }

  closeDialog(){
    this.completed.emit(true)
  }

  unLinkSelectedRecords() {
    const selectedIds: any[] = [];
    for (const varianceNode of this.varianceNodes) {
      if (varianceNode["data"].isSelected) {
        if(varianceNode["data"].id != this.mainRecord.id)
        selectedIds.push(varianceNode["data"].id);
      }
    }
    if (selectedIds.length == 0) {
      this.confirmationService.confirm({
        header: "Info",
        message: "no records selected to unlink.",
        acceptLabel: "Ok",
        rejectVisible: false,
        accept: () => {
          //Actual logic to perform a confirmation
        },
      });
    } else {
      this.confirmationService.confirm({
        header: "Confirm",
        message:
          selectedIds.length.toString() +
          " records will be unlinked, continue ? ",
        accept: () => {
          this.varService
            .submitUnLinkRecords(selectedIds, this.mainRecord.id)
            .subscribe((res: any) => {
              this.updateTable(this.mainRecord)
              this.linkModalRecordsRemoved.emit(res)
            });
        },
      });
    }
  }

  formatName(name: string): string {
    if (!name) return name;
    let formattedName = name.replace(/,\s*/g, ', ');
    
    // Capitalize first letter of each word
    formattedName = formattedName.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
    
    return formattedName;
  }

}
